import { createSlice } from "@reduxjs/toolkit";

const initialState = {
   allProductionStatus: [],
   activeStatus: "WAITING_ON_REPORT",
   isLoading: false,
   isFirstLoading: false,
   mainTableExpandedRowData: null,
   mainLocationTableData: [],
   page: 0,
   dataCount: 0,
   offset: 0,
   dataPerPage: 15,
   searchValue: "",
   sortField: "locationCode",
   sortType: "ASC",
   waitingOnReportSelectedRowData: null,
   waitingOnReportTableActionTrigger: false,
   triggerStatusCountChange: false
};
export const WaitingOnReportSlice = createSlice({
   name: "WaitingOnReport",
   initialState: initialState,
   reducers: {
      setAllProductionStatus: (state, action) => {
         state.allProductionStatus = action.payload;
      },
      setActiveStatus: (state, action) => {
         state.activeStatus = action.payload;
      },
      setIsLoading: (state, action) => {
         state.isLoading = action.payload;
      },
      setIsFirstLoading: (state, action) => {
         state.isFirstLoading = action.payload;
      },
      setMainTableExpandedRowData: (state, action) => {
         state.mainTableExpandedRowData = action.payload;
      },
      setMainLocationTableData: (state, action) => {
         state.mainLocationTableData = action.payload;
      },
      setSearchValue: (state, action) => {
         state.searchValue = { ...state.searchValue, ...action.payload };
      },
      setWaitingOnReportSelectedRowData: (state, action) => {
         state.waitingOnReportSelectedRowData = action.payload;
      },
      setWaitingOnReportTableActionTrigger: (state, action) => {
         state.waitingOnReportTableActionTrigger = action.payload;
      },
      setTriggerStatusCountChange: (state, action) => {
         state.triggerStatusCountChange = action.payload;
      },
      handleProductionWrappingModalClose: (state, action) => {
         state.waitingOnReportSelectedRowData = null;
         state.waitingOnReportTableActionTrigger = true;
         state.triggerStatusCountChange = !state.triggerStatusCountChange;
      },
      setSortField: (state, action) => {
         state.sortField = action.payload;
      },
      setSortType: (state, action) => {
         state.sortType = action.payload;
      },
      setPageConfigData: (state, action) => {
         switch (action.payload.type) {
            case "SET_PAGE":
               state.page = action.payload.data;
               break;
            case "SET_DATA_COUNT":
               state.dataCount = action.payload.data;
               break;
            case "SET_IS_LOADING":
               state.isLoading = action.payload.data;
               break;
            case "SET_DATA_PER_PAGE":
               state.dataPerPage = action.payload.data;
               break;
            case "SET_OFFSET":
               state.offset = action.payload.data;
               break;
            default:
               break;
         }
      },
   },
});

export const {
   setActiveStatus,
   waitingOnReportTableActionTrigger,
   waitingOnReportCountChangeActionTrigger,
   waitingOnReportSelectedRowData,
   handleProductionWrappingModalClose,
} = WaitingOnReportSlice.actions;
